import templateUrl from './case-reference.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    adverseEvent: '<',
    locked: '<'
  },
  controller: class CaseReferenceComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
      this.today = new Date();
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/adverse-event/case-reference/case-reference.component.js